export default __webpack_public_path__ + "static/media/off-4.9295ced3.png";